import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import logo from '../logo.svg'
import styled from 'styled-components';
import {ButtonContainer} from './Button';
import {FaAlignRight} from 'react-icons/fa';
/* 
https://www.iconfinder.com/icons/1243689/call_phone_icon
Creative Commons (Attribution 3.0 Unported);
https://www.iconfinder.com/Makoto_msk */

export default class Navbar extends Component {
  


    render(){
        return(
           <NavWrapper className="navbar navbar-expand-sm bg-primary px-sm-5">
           <Link to ='/'>
           <img src ={logo} alt="store" className="navbar-brand"/>
           </Link>
          
           
    
           <Link to='/' className="nav-link" style={{fontSize:'1.2rem'}}>
           Home</Link>
           <Link to='/products' className="nav-link" style={{fontSize:'1.2rem'}} >
           Products</Link>
           <Link to='/contact' className="nav-link"style={{fontSize:'1.2rem'}}>
           Contact Us</Link> 
           
           <Link to='/cart' className="ml-auto">
           <ButtonContainer>
               <span className="mr-2">
              <i className="fas fa-cart-plus"/>
              </span>
              Cart
           </ButtonContainer>
           </Link>
           </NavWrapper>
        )
    }
}
const NavWrapper = styled.nav`
 .nav-link{
     color:var(--mainWhite)!important;
     font-size:1.4rem;
     text-transfrom:capitalize; 
     color:white;
    border-radius:0.5rem;
    padding: 0.2rem 0.5rem;
    cursor:pointer;
    margin:0.2rem 0.5rem;
     &:hover{
        background:rgba(255,255,255,.10);
        color:white;
    }
    &:focus{
        outline:none;
    }
 }

`

